import { RESULTS } from 'react-native-permissions';
/**
 * See react-native-permissions/README.md for more information.
 */
export var NotificationsPermissionState;
(function (NotificationsPermissionState) {
    NotificationsPermissionState["Unavailable"] = "Unavailable";
    /** GRANTED or LIMITED */
    NotificationsPermissionState["Enabled"] = "Enabled";
    /** BLOCKED */
    NotificationsPermissionState["Disabled"] = "Disabled";
    /** True on iOS if never requested */
    NotificationsPermissionState["Denied"] = "Denied";
})(NotificationsPermissionState || (NotificationsPermissionState = {}));
export const mapNotificationStatusToPermissionState = (status) => {
    switch (status) {
        case RESULTS.GRANTED:
        case RESULTS.LIMITED:
            return NotificationsPermissionState.Enabled;
        case RESULTS.DENIED:
            return NotificationsPermissionState.Denied;
        case RESULTS.BLOCKED:
            return NotificationsPermissionState.Disabled;
        case RESULTS.UNAVAILABLE:
            return NotificationsPermissionState.Unavailable;
        default: {
            const _ = status;
            return NotificationsPermissionState.Unavailable;
        }
    }
};
